module.exports = __webpack_public_path__ + "static/datatable-chart-dont-b16ebf6d3eac51bd4fb5e0fd7a88f099.png";